import { CommonContext } from '@repo-level/core-front';
import { Country } from 'helpers/conf';
import { useContext, useMemo } from 'react';

export const useIsAustralia = () => {
  const { currentIp } = useContext(CommonContext);
  const isAustralia = useMemo(
    () => currentIp?.countryCode === Country.Australia,
    [currentIp]
  );

  return isAustralia;
};
